import React from 'react';
import { motion } from 'framer-motion';
export const AngusSection: React.FC = () => {
  return <section id="angus" className="py-16 px-4 relative overflow-hidden" data-id="element-15">
      <div className="absolute inset-0 bg-fire-texture bg-cover bg-center opacity-20" data-id="element-16"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-pirate-black via-transparent to-pirate-black" data-id="element-17"></div>
      <div className="container mx-auto relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="max-w-4xl mx-auto text-center mb-12" data-id="element-19">
          <h2 className="font-pirata text-3xl md:text-5xl mb-6" data-id="element-20">
            Nuestra Esencia: Carne Angus Certificada
          </h2>
          <p className="text-lg md:text-xl leading-relaxed" data-id="element-21">
            En el corazón de Zacapa, el Perla Negra levanta sus velas con una
            misión clara: ofrecer los cortes de Carne Angus Beef Certificada más
            finos del país. Cada corte cumple con los estándares más exigentes
            de calidad y sabor. Somos la Powerhouse del sabor en el oriente de
            Guatemala.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="rounded-lg overflow-hidden shadow-lg" data-id="element-23">
            <img src="https://images.unsplash.com/photo-1558030006-450675393462?q=80&w=2831&auto=format&fit=crop" alt="Parrilla de carne Angus al fuego" className="w-full h-64 object-cover object-center" data-id="element-24" />
            <div className="p-4 bg-pirate-black bg-opacity-90 border-t-2 border-pirate-red" data-id="element-25">
              <h3 className="font-pirata text-xl mb-2" data-id="element-26">
                Maestría en la parrilla
              </h3>
              <p className="text-gray-300" data-id="element-27">
                El fuego perfecto para sellar los mejores cortes Angus
              </p>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="rounded-lg overflow-hidden shadow-lg" data-id="element-28">
            <img src="https://images.unsplash.com/photo-1615937657715-bc7b4b7962c1?q=80&w=2940&auto=format&fit=crop" alt="Close-up de cortes sellándose" className="w-full h-64 object-cover object-center" data-id="element-29" />
            <div className="p-4 bg-pirate-black bg-opacity-90 border-t-2 border-pirate-red" data-id="element-30">
              <h3 className="font-pirata text-xl mb-2" data-id="element-31">Sellos de perfección</h3>
              <p className="text-gray-300" data-id="element-32">
                El arte de sellar para conservar todos los jugos y sabores
              </p>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="rounded-lg overflow-hidden shadow-lg" data-id="element-33">
            <img src="https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=2938&auto=format&fit=crop" alt="Textura de hierro fundido y luz cálida" className="w-full h-64 object-cover object-center" data-id="element-34" />
            <div className="p-4 bg-pirate-black bg-opacity-90 border-t-2 border-pirate-red" data-id="element-35">
              <h3 className="font-pirata text-xl mb-2" data-id="element-36">
                Experiencia steakhouse
              </h3>
              <p className="text-gray-300" data-id="element-37">
                Ambiente único que combina lo pirata con lo premium
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};